export default {
  en: {
    states: {
      unapproved: 'Unapproved',
      inprogress: 'In review',
      inreview: 'In review',
      approved: 'Approved',
      approvedExpiry: 'Approved, expires {0}',
      rejected: 'Rejected',
      pending_biz: 'Pending business',
      undefined: 'Undefined',
      awaiting_review: 'Awaiting review',
      expired: 'Approval expired',
      pending: 'Pending',
      review_complete: 'Review complete',
      review_expired: 'Review expired',
      unknown: 'Unknown',
    },
    biz_response_page: {
      requested_title: "{name} has requested your approval of {company}'s security assessment.",
      compliance: 'Compliance',
      exemptions_applied: '{number} exemptions applied',
      single_exemption_applied: '{number} exemption applied',
      remediation_requests: '{number} remediations pending',
      single_remediation_request: '{number} remediation pending',
      business_approval_request_error_forbidden:
        'This approval request is now completed, expired or invalidated by a newer request. Contact the original sender for help.',
      business_approval_request_error_unknown:
        'There was a problem finding this business approval request. Contact Risk Ledger for help.',
      business_approval_responded: 'Your response was submitted. You may close this window.',
      business_approval_response_failed:
        'Failed to send response. Try again or contact Risk Ledger.',
    },
    expiredMessage:
      'Your approval expired {0}. Review this supplier again to make sure they meet your policies.',
    nonCompliantControls: {
      tableHeader: 'Non compliant controls',
      riskStatement: 'Risk statement',
      privateNotes: 'Private notes',
    },
    businessApprovalNotes: {
      label: 'Business approval request',
      decisionBy: 'Decision by {email}',
      finalDecision: 'Final decision:',
      recommendationBy: 'Recommendation by {name}',
      originalRecommendation: 'Original recommendation:',
    },
  },
};
